import React, { ReactNode } from 'react';

interface FuturisticCardProps {
  title?: string;
  subtitle?: string;
  children: ReactNode;
  glowColor?: 'primary' | 'secondary' | 'accent';
  hoverEffect?: boolean;
  className?: string;
  cornerAccent?: boolean;
}

const FuturisticCard: React.FC<FuturisticCardProps> = ({
  title,
  subtitle,
  children,
  glowColor = 'primary',
  hoverEffect = true,
  className = '',
  cornerAccent = false,
}) => {
  return (
    <div
      className={[
        'relative bg-neu-bg rounded-neu p-8',
        'shadow-[10px_10px_20px_rgb(163,177,198,0.7),-10px_-10px_20px_rgba(255,255,255,0.65)]',
        hoverEffect
          ? 'transition-all duration-300 ease-out hover:-translate-y-1 hover:shadow-[14px_14px_26px_rgb(163,177,198,0.75),-14px_-14px_26px_rgba(255,255,255,0.7)]'
          : 'transition-shadow duration-300',
        className,
      ].join(' ')}
    >
      {(title || subtitle) && (
        <div className="mb-4">
          {title && <h3 className="text-xl font-bold text-neu-text mb-1">{title}</h3>}
          {subtitle && <p className="text-sm text-neu-muted">{subtitle}</p>}
        </div>
      )}
      {children}
    </div>
  );
};

export default FuturisticCard;
